<template>
  <div>
    <div v-if="showMemberFilter">
      <b-row>
        <b-col sm="3" class="manage-text-filter">
          <b-row>
            <b-col sm="3">
              <b-input size="sm" v-model="memberFilter" @input="$emit('changeMemberFilter', $event)" placeholder="会員番号、氏名"/>
            </b-col>
            <b-col sm="3">
              <b-input size="sm" v-model="productFilter" @input="$emit('changeProductFilter', $event)" placeholder="ASIN/JAN/商品名/追跡番号"/>
            </b-col>
            <b-col sm="3">
              <b-input size="sm" v-model="troubleIdFilter" @input="$emit('changeTroubleIdFilter', $event)" ref="r1" placeholder="管理品番号"/>
            </b-col>
            <b-col sm="3">
              <b-form-select size="sm" v-model="locationFilter" :options="locationTypes" @input="$emit('changeLocationFilter', $event)" class="mb-2"></b-form-select>
            </b-col>
          </b-row>
          <!-- <b-input size="sm" class="tr-fillter-text" v-model="locationFilter" @input="$emit('changeLocationFilter', $event)" placeholder="Location番号"/> -->
        </b-col>
        <b-col sm="2">
          <b-button v-show="!answerFilterflg" size="sm" variant="danger" @click="onAnswerFilter">　回答内容フィルタ表示　</b-button>
          <b-button v-show="answerFilterflg" size="sm" variant="danger" @click="offAnswerFilter">　回答内容フィルタ非表示　</b-button>
        </b-col>
        <b-col sm="1">
          <b-input-group size="sm" prepend="状態">
            <b-select size="sm" v-model="managementFilter" @change="$emit('changeManagementFilter', $event)" :options="managementTypes"/>
          </b-input-group>
        </b-col>
        <b-col sm="2">
          <b-row>
            <b-col sm="4">
              <b-input size="sm" class="text-right" v-model="dayFilter" @input="$emit('changeDayFilter', $event)" placeholder="日数"/>
            </b-col>
            <b-col sm="8">
              <label>日以上経過</label>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="2" @change="$emit('changePastDate', $event)">
          <b-input-group size="sm" prepend="年月指定">
            <b-select size="sm" v-model="monthListFilter" @change="$emit('changeMonthListFilter', $event)" :options="monthListTypes"/>
          </b-input-group>
        </b-col>
        <b-col sm="1">
          <b-checkbox v-model="checkboxDispKako" button-variant="danger" @input="$emit('changeCheckBoxDispKako', $event)">完了分表示</b-checkbox>
        </b-col>
        <b-col sm="1">
          <b-button size="sm" variant="danger" @click="clearLocationNumberFilter">　管理品検索　</b-button>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row>
        <b-col sm="5">
          <b-input size="sm" v-model="productFilter" @input="$emit('changeProductFilter', $event)" placeholder="ASIN/JAN/商品名/追跡番号"/>
        </b-col>
        <b-col sm="4">
          <b-input-group size="sm" prepend="状態">
            <b-select size="sm" v-model="managementFilter" @change="$emit('changeManagementFilter', $event)" :options="managementTypes"/>
          </b-input-group>
        </b-col>
        <b-col sm="3">
          <b-row>
            <b-col sm="4">
              <b-input size="sm" class="text-right" v-model="dayFilter" @input="$emit('changeDayFilter', $event)" placeholder="日数"/>
            </b-col>
            <b-col sm="8">
              <label>日以上経過</label>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-row v-if="answerFilterflg" class="component-margin-top">
      <b-col sm="12">
        <!-- <b-col sm="12" v-if="aaa"> -->
        <b-checkbox v-model="chk1" class="zzz" button-variant="danger" @input="$emit('chk1', $event)">未回答</b-checkbox>
        <b-checkbox v-model="chk2" class="zzz" button-variant="danger" @input="$emit('chk2', $event)">LASに追加登録</b-checkbox>
        <b-checkbox v-model="chk3" class="zzz" button-variant="danger" @input="$emit('chk3', $event)">しばらく保管</b-checkbox>
        <b-checkbox v-model="chk4" class="zzz" button-variant="danger" @input="$emit('chk4', $event)">注文した覚えはありません</b-checkbox>
        <b-checkbox v-model="chk5" class="zzz" button-variant="danger" @input="$emit('chk5', $event)">LAS削除(数量修正)</b-checkbox>
        <b-checkbox v-model="chk6" class="zzz" button-variant="danger" @input="$emit('chk6', $event)">既にLASにあります</b-checkbox>
        <b-checkbox v-model="chk7" class="zzz" button-variant="danger" @input="$emit('chk7', $event)">廃棄</b-checkbox>
        <b-checkbox v-model="chk8" class="zzz" button-variant="danger" @input="$emit('chk8', $event)">返品</b-checkbox>
        <b-checkbox v-model="chk9" class="zzz" button-variant="danger" @input="$emit('chk9', $event)">Amazonに登録完了</b-checkbox>
        <b-checkbox v-model="chk10" class="zzz" button-variant="danger" @input="$emit('chk10', $event)">LASに登録完了</b-checkbox>
        <b-checkbox v-model="chk13" class="zzz" button-variant="danger" @input="$emit('chk13', $event)">5点分割</b-checkbox>
        <b-checkbox v-model="chk14" class="zzz" button-variant="danger" @input="$emit('chk14', $event)">5BOX1SET</b-checkbox>
        <b-checkbox v-model="chk11" class="zzz" button-variant="danger" @input="$emit('chk11', $event)">その他</b-checkbox>
        <b-checkbox v-model="chk12" class="zzz" button-variant="danger" @input="$emit('chk12', $event)">対応済み</b-checkbox>
        <b-button size="sm" variant="danger" @click="checkAllFilter">{{ checkAllFilterMessage }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import ManagementType from '@/types/ManagementType';
import MonthListType from '@/types/MonthListType';
import AnswerType from '@/types/AnswerType';
import DatePicker from '@/components/common/DatePicker';
import LocationType from '@/types/LocationType';

export default {
  mixins: [BaseComponent],
  props: {
    showMemberFilter: { default: false },
    memberFilter: { default: '' },
    productFilter: { default: '' },
    managementFilter: { default: '0' },
    locationFilter: { default: '0' },
    monthListFilter: { default: '' },
    answerFilter: { default: '' },
    dayFilter: { default: '0' },
    troubleIdFilter: { default: '' },
    checkboxDispKako: { default: false },
    pastDate: { default: '' }
  },
  data() {
    return {
      managementTypes: ManagementType.filterValues(),
      monthListTypes: MonthListType.values(),
      answerTypes: AnswerType.values(),
      locationTypes: LocationType.values(),
      dispMonth: true,
      chk1: true,
      chk2: true,
      chk3: true,
      chk4: true,
      chk5: true,
      chk6: true,
      chk7: true,
      chk8: false,
      chk9: true,
      chk10: true,
      chk11: true,
      chk12: true,
      chk13: true,
      chk14: true,
      checkAllFilterMessage: '全てチェックする',
      addclearbtn: true,
      answerFilterflg: false
    };
  },
  methods: {
    checkAllFilter(){
      if(this.checkAllFilterMessage === '全てチェックする'){
        this.chk1 = true;
        this.chk2 = true;
        this.chk3 = true;
        this.chk4 = true;
        this.chk5 = true;
        this.chk6 = true;
        this.chk7 = true;
        this.chk8 = true;
        this.chk9 = true;
        this.chk10 = true;
        this.chk11 = true;
        this.chk12 = true;
        this.chk13 = true;
        this.chk14 = true;
        this.checkAllFilterMessage = '全チェックを外す';
        this.$emit('checkAllFilter', 'ON');
      } else{
        this.chk1 = false;
        this.chk2 = false;
        this.chk3 = false;
        this.chk4 = false;
        this.chk5 = false;
        this.chk6 = false;
        this.chk7 = false;
        this.chk8 = false;
        this.chk9 = false;
        this.chk10 = false;
        this.chk11 = false;
        this.chk12 = false;
        this.chk13 = false;
        this.chk14 = false;
        this.checkAllFilterMessage = '全てチェックする';
        this.$emit('checkAllFilter', 'OFF');
      }
      this.$refs.r1.focus();
      this.troubleIdFilter = '';
      this.$emit('changeTroubleIdFilter', '');
    },
    clearLocationNumberFilter(){
      this.$refs.r1.focus();
      this.troubleIdFilter = '';
      this.$emit('changeTroubleIdFilter', '');
    },
    onAnswerFilter(){
      this.answerFilterflg = true;
    },
    offAnswerFilter(){
      this.answerFilterflg = false;
    }
  }
};

Vue.component('date-picker', DatePicker);
</script>


<style scoped>
.zzz{
  /* width: 3rem; */
  display: inline-block;
  margin-right: 1rem;
}
.component-margin-top {
  margin-top: 1rem;
}
.tr-fillter-text {
  margin-right: 1rem;
  width: 5rem;
}
.manage-text-filter{
  display: flex;
  flex-direction: row;
  align-items: center;
}

</style>